export const GetStartedCTA = () => {
    return (
        <section id="get-started-cta">
            <h2>Unleash the power of teamwork</h2>
            <hr />
        </section>
    );
};
